/** @jsxImportSource react */
import PostConversionModal from '@react/cta/components/PostConversionModal';
import CtaButton from '@react/cta/CtaButton';
import useCta from '@react/cta/hooks/useCta';
import { Button } from '@react/system';
import { Checkmark } from '@sly/icons/react';
import { object } from 'proptypes';
import React from 'react';

export default function withPostConversionModal(InnerComponent) {
  const Wrapper = (props) => {
    const {
      community,
      mode,
      buttonStyle,
      ctaProps,
      eventProps,
      CustomSuccessButton,
      params,
      className,
    } = props;
    const {
      variant = 'primary',
      palette = 'viridian',
      text: ctaButtonText,
    } = ctaProps;

    const {
      agent,
      pricingRequested,
      completedAssessment,
      modalOpened,
      startAssessmentFlow,
      completedAssessmentFlow,
      toggleModal,
      isClientSide,
    } = useCta({
      community,
      mode,
      params,
    });

    if (pricingRequested) {
      if (CustomSuccessButton) {
        return <CustomSuccessButton />;
      }
      return (
        <Button
          className='grid h-max w-full cursor-[unset] grid-cols-[min-content_min-content] justify-center gap-s'
          disabled={pricingRequested}
          data-tp-id='gen-Button-33aeead9-b0e4-4bea-b8b1-0cea66e463a3'
        >
          <Checkmark />
          <div data-tp-id='gen-div-d69d8f93-9332-400a-9634-11fcbf05809b'>
            Pricing Requested
          </div>
        </Button>
      );
    }

    // hack to supress hydration mismatch error(use suspense)
    if (completedAssessment && isClientSide) {
      return (
        <>
          <CtaButton
            variant={variant}
            palette={palette}
            textAlign='center'
            onClick={completedAssessmentFlow}
            eventProps={eventProps}
            className={className}
            {...buttonStyle}
          >
            {ctaButtonText || 'Get access'}
          </CtaButton>
          {modalOpened && (
            <PostConversionModal
              agent={agent}
              community={community}
              modalOpened={modalOpened}
              toggleModal={toggleModal}
            />
          )}
        </>
      );
    }

    return (
      <InnerComponent {...props} startAssessmentFlow={startAssessmentFlow} />
    );
  };

  Wrapper.propTypes = {
    community: object,
    mode: object,
    ctaProps: object,
    buttonStyle: object,
  };

  return Wrapper;
}
